// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AddTicketMessageData, AddTicketMessageErrors, AddTicketMessageResponses, CancelAccountDeletionData, CancelAccountDeletionErrors, CancelAccountDeletionResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ConfirmEmailData, ConfirmEmailErrors, ConfirmEmailResponses, ConfirmMfaEnrollmentData, ConfirmMfaEnrollmentErrors, ConfirmMfaEnrollmentResponses, CreateTicketData, CreateTicketErrors, CreateTicketResponses, DeleteListData, DeleteListErrors, DeleteListResponses, DeleteTaskAlertData, DeleteTaskAlertErrors, DeleteTaskAlertResponses, DeleteTaskCompletionData, DeleteTaskCompletionErrors, DeleteTaskCompletionResponses, DeleteTaskData, DeleteTaskErrors, DeleteTaskResponses, DisableMfaData, DisableMfaErrors, DisableMfaResponses, EnrollMfaData, EnrollMfaErrors, EnrollMfaResponses, ExportAccountData, ExportAccountErrors, ExportAccountResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetAccountDeletionData, GetAccountDeletionErrors, GetAccountDeletionResponses, GetHealthData, GetHealthErrors, GetHealthResponses, GetListData, GetListErrors, GetListResponses, GetMeData, GetMeErrors, GetMeResponses, GetPlanUsageData, GetPlanUsageErrors, GetPlanUsageResponses, GetTaskAlertData, GetTaskAlertErrors, GetTaskAlertResponses, GetTaskCompletionData, GetTaskCompletionErrors, GetTaskCompletionResponses, GetTaskData, GetTaskErrors, GetTaskResponses, GetTicketData, GetTicketErrors, GetTicketResponses, ListListsData, ListListsErrors, ListListsResponses, ListTaskAlertsData, ListTaskAlertsErrors, ListTaskAlertsResponses, ListTaskCompletionsData, ListTaskCompletionsErrors, ListTaskCompletionsResponses, ListTasksData, ListTasksErrors, ListTasksResponses, ListTicketsData, ListTicketsErrors, ListTicketsResponses, PatchListData, PatchListErrors, PatchListResponses, PatchTaskAlertData, PatchTaskAlertErrors, PatchTaskAlertResponses, PatchTaskCompletionData, PatchTaskCompletionErrors, PatchTaskCompletionResponses, PatchTaskData, PatchTaskErrors, PatchTaskResponses, PutListData, PutListErrors, PutListResponses, PutTaskAlertData, PutTaskAlertErrors, PutTaskAlertResponses, PutTaskCompletionData, PutTaskCompletionErrors, PutTaskCompletionResponses, PutTaskData, PutTaskErrors, PutTaskResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RequestAccountDeletionData, RequestAccountDeletionErrors, RequestAccountDeletionResponses, RequestMagicLinkData, RequestMagicLinkErrors, RequestMagicLinkResponses, ResendConfirmationData, ResendConfirmationErrors, ResendConfirmationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RevenueCatWebhookData, RevenueCatWebhookErrors, RevenueCatWebhookResponses, SetTicketStatusData, SetTicketStatusErrors, SetTicketStatusResponses, SignInData, SignInErrors, SignInResponses, SignOutData, SignOutErrors, SignOutResponses, SignUpData, SignUpErrors, SignUpResponses, SubmitContactData, SubmitContactErrors, SubmitContactResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, UpdateMeData, UpdateMeErrors, UpdateMeResponses, VerifyMagicLinkData, VerifyMagicLinkErrors, VerifyMagicLinkResponses, VerifyMfaData, VerifyMfaErrors, VerifyMfaResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Cancel a scheduled deletion
 */
export const cancelAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<CancelAccountDeletionData, ThrowOnError>): RequestResult<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).delete<CancelAccountDeletionResponses, CancelAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Current deletion request, if any
 */
export const getAccountDeletion = <ThrowOnError extends boolean = false>(options?: Options<GetAccountDeletionData, ThrowOnError>): RequestResult<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError> => (options?.client ?? client).get<GetAccountDeletionResponses, GetAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options
});

/**
 * Schedule the account for deletion
 */
export const requestAccountDeletion = <ThrowOnError extends boolean = false>(options: Options<RequestAccountDeletionData, ThrowOnError>): RequestResult<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError> => (options.client ?? client).post<RequestAccountDeletionResponses, RequestAccountDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/deletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export all of the user's data
 */
export const exportAccount = <ThrowOnError extends boolean = false>(options?: Options<ExportAccountData, ThrowOnError>): RequestResult<ExportAccountResponses, ExportAccountErrors, ThrowOnError> => (options?.client ?? client).get<ExportAccountResponses, ExportAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/account/export',
    ...options
});

/**
 * Confirm an email address
 */
export const confirmEmail = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailData, ThrowOnError>): RequestResult<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError> => (options.client ?? client).post<ConfirmEmailResponses, ConfirmEmailErrors, ThrowOnError>({
    url: '/v1/auth/email/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend the confirmation email
 */
export const resendConfirmation = <ThrowOnError extends boolean = false>(options: Options<ResendConfirmationData, ThrowOnError>): RequestResult<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError> => (options.client ?? client).post<ResendConfirmationResponses, ResendConfirmationErrors, ThrowOnError>({
    url: '/v1/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signed-in user
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options
});

/**
 * Update the signed-in user
 */
export const updateMe = <ThrowOnError extends boolean = false>(options: Options<UpdateMeData, ThrowOnError>): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn off two-factor authentication (needs an MFA-verified session)
 */
export const disableMfa = <ThrowOnError extends boolean = false>(options?: Options<DisableMfaData, ThrowOnError>): RequestResult<DisableMfaResponses, DisableMfaErrors, ThrowOnError> => (options?.client ?? client).post<DisableMfaResponses, DisableMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/disable',
    ...options
});

/**
 * Begin two-factor enrolment
 */
export const enrollMfa = <ThrowOnError extends boolean = false>(options?: Options<EnrollMfaData, ThrowOnError>): RequestResult<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError> => (options?.client ?? client).post<EnrollMfaResponses, EnrollMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll',
    ...options
});

/**
 * Confirm enrolment with a code
 */
export const confirmMfaEnrollment = <ThrowOnError extends boolean = false>(options: Options<ConfirmMfaEnrollmentData, ThrowOnError>): RequestResult<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<ConfirmMfaEnrollmentResponses, ConfirmMfaEnrollmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/mfa/enroll/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish a two-factor sign-in
 */
export const verifyMfa = <ThrowOnError extends boolean = false>(options: Options<VerifyMfaData, ThrowOnError>): RequestResult<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError> => (options.client ?? client).post<VerifyMfaResponses, VerifyMfaErrors, ThrowOnError>({
    url: '/v1/auth/mfa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a sign-in link
 */
export const requestMagicLink = <ThrowOnError extends boolean = false>(options: Options<RequestMagicLinkData, ThrowOnError>): RequestResult<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<RequestMagicLinkResponses, RequestMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with an emailed token
 */
export const verifyMagicLink = <ThrowOnError extends boolean = false>(options: Options<VerifyMagicLinkData, ThrowOnError>): RequestResult<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError> => (options.client ?? client).post<VerifyMagicLinkResponses, VerifyMagicLinkErrors, ThrowOnError>({
    url: '/v1/auth/otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change password
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/password/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email a password reset link
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a new password using an emailed token
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/v1/auth/password/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate the refresh token
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 */
export const signIn = <ThrowOnError extends boolean = false>(options: Options<SignInData, ThrowOnError>): RequestResult<SignInResponses, SignInErrors, ThrowOnError> => (options.client ?? client).post<SignInResponses, SignInErrors, ThrowOnError>({
    url: '/v1/auth/sign-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke the current session
 */
export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError> => (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/sign-out',
    ...options
});

/**
 * Create an account
 */
export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>): RequestResult<SignUpResponses, SignUpErrors, ThrowOnError> => (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    url: '/v1/auth/sign-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a contact message
 */
export const submitContact = <ThrowOnError extends boolean = false>(options: Options<SubmitContactData, ThrowOnError>): RequestResult<SubmitContactResponses, SubmitContactErrors, ThrowOnError> => (options.client ?? client).post<SubmitContactResponses, SubmitContactErrors, ThrowOnError>({
    url: '/v1/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send feedback
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    url: '/v1/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Liveness and database check
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, GetHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({ url: '/v1/health', ...options });

/**
 * List List rows (delta sync)
 */
export const listLists = <ThrowOnError extends boolean = false>(options?: Options<ListListsData, ThrowOnError>): RequestResult<ListListsResponses, ListListsErrors, ThrowOnError> => (options?.client ?? client).get<ListListsResponses, ListListsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/lists',
    ...options
});

/**
 * Delete a List (soft by default)
 */
export const deleteList = <ThrowOnError extends boolean = false>(options: Options<DeleteListData, ThrowOnError>): RequestResult<DeleteListResponses, DeleteListErrors, ThrowOnError> => (options.client ?? client).delete<DeleteListResponses, DeleteListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/lists/{id}',
    ...options
});

/**
 * Get one List
 */
export const getList = <ThrowOnError extends boolean = false>(options: Options<GetListData, ThrowOnError>): RequestResult<GetListResponses, GetListErrors, ThrowOnError> => (options.client ?? client).get<GetListResponses, GetListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/lists/{id}',
    ...options
});

/**
 * Update fields of a List
 */
export const patchList = <ThrowOnError extends boolean = false>(options: Options<PatchListData, ThrowOnError>): RequestResult<PatchListResponses, PatchListErrors, ThrowOnError> => (options.client ?? client).patch<PatchListResponses, PatchListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/lists/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a List (idempotent)
 */
export const putList = <ThrowOnError extends boolean = false>(options: Options<PutListData, ThrowOnError>): RequestResult<PutListResponses, PutListErrors, ThrowOnError> => (options.client ?? client).put<PutListResponses, PutListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/lists/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Plan limits and usage
 */
export const getPlanUsage = <ThrowOnError extends boolean = false>(options?: Options<GetPlanUsageData, ThrowOnError>): RequestResult<GetPlanUsageResponses, GetPlanUsageErrors, ThrowOnError> => (options?.client ?? client).get<GetPlanUsageResponses, GetPlanUsageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/plan',
    ...options
});

/**
 * List TaskAlert rows (delta sync)
 */
export const listTaskAlerts = <ThrowOnError extends boolean = false>(options?: Options<ListTaskAlertsData, ThrowOnError>): RequestResult<ListTaskAlertsResponses, ListTaskAlertsErrors, ThrowOnError> => (options?.client ?? client).get<ListTaskAlertsResponses, ListTaskAlertsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-alerts',
    ...options
});

/**
 * Delete a TaskAlert (soft by default)
 */
export const deleteTaskAlert = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskAlertData, ThrowOnError>): RequestResult<DeleteTaskAlertResponses, DeleteTaskAlertErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskAlertResponses, DeleteTaskAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-alerts/{id}',
    ...options
});

/**
 * Get one TaskAlert
 */
export const getTaskAlert = <ThrowOnError extends boolean = false>(options: Options<GetTaskAlertData, ThrowOnError>): RequestResult<GetTaskAlertResponses, GetTaskAlertErrors, ThrowOnError> => (options.client ?? client).get<GetTaskAlertResponses, GetTaskAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-alerts/{id}',
    ...options
});

/**
 * Update fields of a TaskAlert
 */
export const patchTaskAlert = <ThrowOnError extends boolean = false>(options: Options<PatchTaskAlertData, ThrowOnError>): RequestResult<PatchTaskAlertResponses, PatchTaskAlertErrors, ThrowOnError> => (options.client ?? client).patch<PatchTaskAlertResponses, PatchTaskAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-alerts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a TaskAlert (idempotent)
 */
export const putTaskAlert = <ThrowOnError extends boolean = false>(options: Options<PutTaskAlertData, ThrowOnError>): RequestResult<PutTaskAlertResponses, PutTaskAlertErrors, ThrowOnError> => (options.client ?? client).put<PutTaskAlertResponses, PutTaskAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-alerts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List TaskCompletion rows (delta sync)
 */
export const listTaskCompletions = <ThrowOnError extends boolean = false>(options?: Options<ListTaskCompletionsData, ThrowOnError>): RequestResult<ListTaskCompletionsResponses, ListTaskCompletionsErrors, ThrowOnError> => (options?.client ?? client).get<ListTaskCompletionsResponses, ListTaskCompletionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-completions',
    ...options
});

/**
 * Delete a TaskCompletion (soft by default)
 */
export const deleteTaskCompletion = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskCompletionData, ThrowOnError>): RequestResult<DeleteTaskCompletionResponses, DeleteTaskCompletionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskCompletionResponses, DeleteTaskCompletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-completions/{id}',
    ...options
});

/**
 * Get one TaskCompletion
 */
export const getTaskCompletion = <ThrowOnError extends boolean = false>(options: Options<GetTaskCompletionData, ThrowOnError>): RequestResult<GetTaskCompletionResponses, GetTaskCompletionErrors, ThrowOnError> => (options.client ?? client).get<GetTaskCompletionResponses, GetTaskCompletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-completions/{id}',
    ...options
});

/**
 * Update fields of a TaskCompletion
 */
export const patchTaskCompletion = <ThrowOnError extends boolean = false>(options: Options<PatchTaskCompletionData, ThrowOnError>): RequestResult<PatchTaskCompletionResponses, PatchTaskCompletionErrors, ThrowOnError> => (options.client ?? client).patch<PatchTaskCompletionResponses, PatchTaskCompletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-completions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a TaskCompletion (idempotent)
 */
export const putTaskCompletion = <ThrowOnError extends boolean = false>(options: Options<PutTaskCompletionData, ThrowOnError>): RequestResult<PutTaskCompletionResponses, PutTaskCompletionErrors, ThrowOnError> => (options.client ?? client).put<PutTaskCompletionResponses, PutTaskCompletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/task-completions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Task rows (delta sync)
 */
export const listTasks = <ThrowOnError extends boolean = false>(options?: Options<ListTasksData, ThrowOnError>): RequestResult<ListTasksResponses, ListTasksErrors, ThrowOnError> => (options?.client ?? client).get<ListTasksResponses, ListTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks',
    ...options
});

/**
 * Delete a Task (soft by default)
 */
export const deleteTask = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskData, ThrowOnError>): RequestResult<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{id}',
    ...options
});

/**
 * Get one Task
 */
export const getTask = <ThrowOnError extends boolean = false>(options: Options<GetTaskData, ThrowOnError>): RequestResult<GetTaskResponses, GetTaskErrors, ThrowOnError> => (options.client ?? client).get<GetTaskResponses, GetTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{id}',
    ...options
});

/**
 * Update fields of a Task
 */
export const patchTask = <ThrowOnError extends boolean = false>(options: Options<PatchTaskData, ThrowOnError>): RequestResult<PatchTaskResponses, PatchTaskErrors, ThrowOnError> => (options.client ?? client).patch<PatchTaskResponses, PatchTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update a Task (idempotent)
 */
export const putTask = <ThrowOnError extends boolean = false>(options: Options<PutTaskData, ThrowOnError>): RequestResult<PutTaskResponses, PutTaskErrors, ThrowOnError> => (options.client ?? client).put<PutTaskResponses, PutTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List my tickets
 */
export const listTickets = <ThrowOnError extends boolean = false>(options?: Options<ListTicketsData, ThrowOnError>): RequestResult<ListTicketsResponses, ListTicketsErrors, ThrowOnError> => (options?.client ?? client).get<ListTicketsResponses, ListTicketsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options
});

/**
 * Open a ticket
 */
export const createTicket = <ThrowOnError extends boolean = false>(options: Options<CreateTicketData, ThrowOnError>): RequestResult<CreateTicketResponses, CreateTicketErrors, ThrowOnError> => (options.client ?? client).post<CreateTicketResponses, CreateTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One of my tickets with its conversation
 */
export const getTicket = <ThrowOnError extends boolean = false>(options: Options<GetTicketData, ThrowOnError>): RequestResult<GetTicketResponses, GetTicketErrors, ThrowOnError> => (options.client ?? client).get<GetTicketResponses, GetTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}',
    ...options
});

/**
 * Add a note to a ticket
 */
export const addTicketMessage = <ThrowOnError extends boolean = false>(options: Options<AddTicketMessageData, ThrowOnError>): RequestResult<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError> => (options.client ?? client).post<AddTicketMessageResponses, AddTicketMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close or reopen a ticket
 */
export const setTicketStatus = <ThrowOnError extends boolean = false>(options: Options<SetTicketStatusData, ThrowOnError>): RequestResult<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError> => (options.client ?? client).post<SetTicketStatusResponses, SetTicketStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tickets/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * RevenueCat server-to-server event
 */
export const revenueCatWebhook = <ThrowOnError extends boolean = false>(options: Options<RevenueCatWebhookData, ThrowOnError>): RequestResult<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError> => (options.client ?? client).post<RevenueCatWebhookResponses, RevenueCatWebhookErrors, ThrowOnError>({
    url: '/v1/webhooks/revenuecat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
